import React from 'react';
import type { SvgProperties } from '@components-shared/src/stitches';

export const Mirror = ({ fill = '#525252' }: { fill?: SvgProperties['fill'] }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1249 7.66673C21.1249 7.6667 21.1249 7.66667 21.1249 7.66664C21.1249 3.43247 17.2634 0 12.4999 0C7.73652 0 3.875 3.43247 3.875 7.66664C3.875 7.66667 3.875 7.6667 3.875 7.66673V23H21.1249V7.66673Z"
      fill={fill}
    />
  </svg>
);
